import React, { Component } from 'react'

import { Button, Grid } from '@mui/material'
import { Link } from 'react-router-dom'
import { UrlProvider } from 'urls'

import { FormTextField, FormToggle } from 'components/input'
import { DescriptionListTable } from 'components/table'
import { withForm } from 'decorators/withForm'
import { userEditValidator } from 'validators/user'

type UserEditFormProps = {
  handleSubmit: (...args: any[]) => any
  id: number
  onSubmit: (...args: any[]) => any
}

class UserEditForm extends Component<UserEditFormProps> {
  getConfig = () => [
    {
      title: 'First name',
      render: () => <FormTextField name="first_name" />,
    },
    {
      title: 'Last name',
      render: () => <FormTextField name="last_name" />,
    },
    {
      title: 'E-mail',
      render: () => <FormTextField name="email" />,
    },
    {
      title: 'Albacross admin',
      render: () => <FormToggle name="admin" />,
    },
  ]

  render() {
    const { handleSubmit, onSubmit, id } = this.props

    return (
      <form onSubmit={handleSubmit(onSubmit)}>
        <Grid container spacing={2}>
          <Grid
            size={{
              sm: 12,
            }}>
            <DescriptionListTable config={this.getConfig()} />
          </Grid>
          <Grid
            size={{
              sm: 1,
            }}>
            <Link to={UrlProvider.getUrl('user', { id })}>
              <Button fullWidth variant="contained">
                Cancel
              </Button>
            </Link>
          </Grid>
          <Grid
            size={{
              sm: 1,
            }}>
            <Button color="secondary" fullWidth type="submit" variant="contained">
              Update
            </Button>
          </Grid>
        </Grid>
      </form>
    )
  }
}

export default withForm({
  form: 'userEdit',
  validate: userEditValidator,
})(UserEditForm)
